import BaseApi from "./BaseApi";

const baseUrl = 'api/event/';

class EventService {

    static GetEvents(): Promise<any> {
        return BaseApi.get(`${baseUrl}ListEvents`);
    }

    static GetEventById(event: any): Promise<any> {
        return BaseApi.get(`${baseUrl}${event}`);
    }

    static CheckEventPay() {
        return BaseApi.get(`${baseUrl}eventPayCheck`);
    }
    static HideEventPay(id: number) {
        return BaseApi.put(`${baseUrl}HideEventPay/${id}`);
    }

    static putActive(request: any): Promise<any> {
        return BaseApi.put(`${baseUrl}updateEvent`, request);
    }
    static put(request: any): Promise<any> {
        return BaseApi.put(`${baseUrl}`, request);
    }
    
    static post(request: any): Promise<any> {
        return BaseApi.post(`${baseUrl}`, request);
    }

    static postUser(request: any): Promise<any> {
        return BaseApi.post(`${baseUrl}insertUsersEvent`, request);
    }

    static Delete(id: number): Promise<any> {
        return BaseApi.delete(`${baseUrl}delEvent/${id}`);
    }
}

export default EventService;